export default __webpack_public_path__ + "static/media/reprove-register.34315f10.svg";